(function () {
  if (window.dpcReady) return;
  window.dpcReady = true;

  // variant dropdown updates the card price
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-dpc-select]');
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    var card = select.closest('[data-dpc]');
    var price = card && card.querySelector('[data-dpc-price]');
    if (!price) return;
    var html = '<span class="dpc__price-sale">' + opt.dataset.price + '</span>';
    if (opt.dataset.compare) html += '<s class="dpc__price-compare">' + opt.dataset.compare + '</s>';
    price.innerHTML = html;
  });

  // ADD TO CART: add without leaving the page and open the theme cart drawer; fall back to the normal form post
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-dpc-form]');
    if (!form || !window.fetch) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    e.preventDefault();
    var btn = form.querySelector('.dpc__atc');
    if (btn) btn.classList.add('is-loading');
    var data = new FormData(form);
    if (!data.has('quantity')) data.append('quantity', '1');
    data.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
    data.append('sections_url', window.location.pathname);
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { form.submit(); return; }
        drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });
})();
